export interface Testimonial {
  id: string;
  text: string;
  author: string;
  title: string;
  company: string;
}

export interface TestimonialsData {
  testimonials: {
    tag: string;
    title: string;
    description: string;
    items: Testimonial[];
  };
}

export const TestimonialsConstants: TestimonialsData = {
  testimonials: {
    tag: "Testimonials",
    title: "Hear From Our Community",
    description:
      "Hear from genuine users who have engaged with our platform directly. Discover their insights on the quality, dependability, and user-friendliness that distinguish our service.",
    items: [
      {
        id: "1",
        text: "CricCenter is a very good scoring app with a helpful support team. They solve issues quickly, whether during the match or after the match. The scoring buttons are easy to use, the graphics look great, and the app also offers detailed ball-by-ball scoring. ",
        author: "Omkar Nalawade",
        title: "SCORER",
        company: "BCA",
      },
      {
        id: "2",
        text: "CricCenter is a fantastic new scoring and streaming app with beautiful graphics and an incredibly easy workflow. Using it in Houston, we found it precise, smooth, and perfect for commentators and broadcasters.",
        author: "Shobhith Kannan",
        title: "STREAMER",
        company: "BLP",
      },
      {
        id: "3",
        text: "CricCenter is a powerful addition to the market—combining intuitive design, precise scoring, and high-quality graphics. Our experience in Houston was excellent, especially for broadcast and commentary use",
        author: "Swayan Prakash",
        title: "STREAMER",
        company: "",
      },

      {
        id: "4",
        text: "Hello everyone I am Harendra Patel we have arrange CREDAI CRICKET LEAGUE 2026. This tournament only participations from Vadodara Builder Association I am the member of Credai cricket league and we are organizing since 2016 this is our eighth edition of CCL 2026 and we hired Cric center for the scoring and Streaming of the whole tournament and we have a great experience with their staff and accurately done through the application. CricCenter is part of CREDAI Now.",
        author: "HARENDRA M PATEL",
        title: "MEMBER",
        company: "CREDAI",
      },
      // {
      //     id: "5",
      //     text: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident.",
      //     author: "Alliana Mill",
      //     title: "Director",
      //     company: "ABC Corp"
      // },
      // {
      //     id: "6",
      //     text: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident.",
      //     author: "Alliana Mill",
      //     title: "Director",
      //     company: "ABC Corp"
      // },
      // {
      //     id: "7",
      //     text: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident.",
      //     author: "Alliana Mill",
      //     title: "Director",
      //     company: "ABC Corp"
      // }
    ],
  },
};
